(function($) { 
    function siteToggleAction() {
        var navSidebar = $('.navigation--sidebar'),
            filterSidebar = $('.ps-filter--sidebar');
        $('.menu-toggle-open').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            navSidebar.toggleClass('active');
            $('.ps-site-overlay').toggleClass('active');
        });

        $('.ps-toggle--sidebar').on('click', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $(this).toggleClass('active');
            $(this)
                .siblings('a')
                .removeClass('active');
            $(url).toggleClass('active');
            $(url)
                .siblings('.ps-panel--sidebar')
                .removeClass('active');
            $('.ps-site-overlay').toggleClass('active');
        });

        $('#filter-sidebar').on('click', function(e) {
            e.preventDefault();
            filterSidebar.addClass('active');
            $('.ps-site-overlay').addClass('active');
        });

        $('.ps-filter--sidebar .ps-filter__header .ps-btn--close').on(
            'click',
            function(e) {
                e.preventDefault();
                filterSidebar.removeClass('active');
                $('.ps-site-overlay').removeClass('active');
            }
        );

      
    }

    function subMenuToggle() {
        $('.menu--mobile .menu-item-has-children > .sub-toggle').on(
            'click',
            function(e) {
              console.log(0);
                e.preventDefault();
                var current = $(this).parent('.menu-item-has-children');
                $(this).toggleClass('active');
                //current.siblings().find('.sub-toggle').removeClass('active');
                //current.children('.sub-menu').slideToggle(350);
                //current.siblings().find('.sub-menu').slideUp(350);
              	current.children('.sub-menu').toggleClass('is-open');
                if (current.hasClass('has-mega-menu')) {
                    //current.children('.mega-menu').slideToggle(350);
                  	
                  
                  	current.children('.mega-menu').toggleClass('is-open');
                  	
                  
                    //current.siblings('.has-mega-menu').find('.mega-menu').slideUp(350);
                }
            }
        );
        $('.menu--mobile .has-mega-menu .mega-menu__column .sub-toggle').on(
            'click',
            function(e) {
              console.log(1);
                e.preventDefault();
                var current = $(this).closest('.mega-menu__column');
                $(this).toggleClass('active');
                //current.siblings().find('.sub-toggle').removeClass('active');
                current.children('.mega-menu__list').slideToggle(350);
                //current.siblings().find('.mega-menu__list').slideUp(350);
            }
        );
        var listCategories = $('.ps-list--categories');
        if (listCategories.length > 0) {
            /*$('.ps-list--categories .menu-item-has-children > .sub-toggle').on(
                'click',
                function(e) {
                    e.preventDefault();
                    var current = $(this).parent('.menu-item-has-children');
                  	//if($(this).hasClass('active'))
                      
                    $(this).toggleClass('active');
                    current
                        .siblings()
                        .find('.sub-toggle')
                        .removeClass('active');
                    //current.children('.sub-menu').slideToggle(350);
                    current
                        .siblings()
                        .find('.sub-menu')
                        .slideUp(350);
                    if (current.hasClass('has-mega-menu')) {
                        current.children('.mega-menu').slideToggle(350);
                        current
                            .siblings('.has-mega-menu')
                            .find('.mega-menu')
                            .slideUp(350);
                    }
                }
            );*/
        }
    }

    
    $(function() {
        siteToggleAction();
        subMenuToggle();
        
    });

  /*$(document).on('click', ".drawer__close", function(){
    $('.ps-toggle--sidebar').trigger("click");
  });*/
  
  //  $(document).on('click', ".a-mega-second-link", function(){
  //     $(this).find('.sub-toggle').trigger("click");
  //   });
  
})(jQuery);
